/**
 * ```
    $state.go(STATE_MAPPINGS.notifications);
 * ```  
 * ### Properties
 * #### Inputs
 */
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state displays user notifications
///

// Register the application's routes configuration.
angular.module('flowingly.runner.user.notifications').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.notifications, {
    url: 'usernotifications',
    params: { userId: null, title: 'Notifications' },
    templateUrl:
      'Client/runner.user.notifications/runner.user.notifications.tmpl.html'
  });
}
